import "./careers-section.css";
import { useTranslation } from "react-i18next";

export default function CareersSection() {
  const {t} = useTranslation();
  const jobs = [
    {
      title: "FULL STACK JAVA DEVELOPER",
      experience: "Experience: 3 - 6 Years | Job Type: Full-time",
      description:
        "Work with product owners/BA to understand detailed requirements and design complete user experiences that meet business needs and vision. Participates in the design, development, and implementation of complex portal applications.",
    },
    {
      title: "UI/UX DESIGNER",
      experience: "Experience: 2 - 4 Years | Job Type: Full-time",
      description:
        "Create visually appealing and user-friendly interfaces. Collaborate closely with developers and product teams to deliver seamless design solutions that enhance user engagement.",
    },
    {
      title: "DEVOPS ENGINEER",
      experience: "Experience: 3 - 4 Years | Job Type: Full-time",
      description:
        "Implement CI/CD pipelines, monitor system performance, and maintain scalable cloud infrastructure to ensure reliability and fast delivery of software applications.",
    },
    {
      title: "QA LEAD/MANAGER",
      experience: "Experience: 6 - 8 Years | Job Type: Full-time",
      description:
        "Lead QA engineers into developing performance & functional test plans and test scenarios using requirements and product documentation while specifying testing overview, approach, strategy, scope, architecture, environment, roles and responsibilities.",
    },
    {
      title: "UI DEVELOPER",
      experience: "Experience: 2 - 6 Years | Job Type: Full-time",
      description:
        "Facilitate product owners visions by researching, conceiving, prototyping, and mocking up user experiences for portal applications. Make strategic design and user-experience decisions related to core, and new, functions, and features.",
    },
  ];

  return (
    <div>
      <div className="careers-section-details">
        <h6 className="main-heading">{t("Careers")}</h6>
        <h1 className="main-sub-heading">{t("Explore Career Options at Sigvion")}</h1>
        <p className="main-description">
          {t("Join our growing team and unlock the opportunity to work professionally, collaborate, and grow together toward shared success.")}
        </p>
      </div>
      <div className="job-section">
        {jobs.map((job, index) => (
          <div className="job-card" key={index}>
            <div className="job-header">
              <div className="job-info">
                <h3>{t(job.title)}</h3>
                <p>{t(job.experience)}</p>
              </div>
              <i className="fa-solid fa-chevron-right"></i>
            </div>
            <p className="job-description">{t(job.description)}</p>
          </div>
        ))}
      </div>
      <div className="join-us-section">
        <h6>{t("Would you like to join our team?")}</h6>
        <p>{t("Send us your portfolio and CV to")}</p>
        <a href="mailto:contact@sigvion.com">contact@sigvion.com</a>
      </div>
    </div>
  );
}
